export function canvasPerfNow() {
  if (typeof performance !== "undefined" && performance.now) {
    return performance.now();
  }
  return Date.now();
}

export function canvasPerfElapsedMs(startedAt) {
  return Math.round(canvasPerfNow() - startedAt);
}

export function isCanvasPerfLoggingEnabled() {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem("wf86.disableCanvasPerfLogs") !== "1";
  } catch (_) {
    return true;
  }
}

export function logCanvasPerf(event, details = {}) {
  if (!isCanvasPerfLoggingEnabled()) return;
  console.info("[canvas-perf]", event, {
    ...details,
    atMs: Math.round(canvasPerfNow()),
  });
}
